import { render } from "./LittleArrowForward.vue?vue&type=template&id=3c133e8c"
const script = {}
script.render = render

export default script